/**
 * Question action constants
 *
 * @type {string}
 */
export const UPDATE_TRANSITION_STATE = "UPDATE_TRANSITION_STATE"
export const SET_NEXT_QUESTION = "SET_NEXT_QUESTION"


/**
 *
 * @param transitionState
 * @returns {{type: string, transitionState: *}}
 */
export const updateTransitionState = (transitionState, direction) => ({
  type: UPDATE_TRANSITION_STATE,
  transitionState,
  direction
})

/**
 *
 * @param nextQuestionObj
 * @returns {{type: string, nextQuestionObj: *}}
 */
export const setNextQuestion = (nextQuestionObj) => ({
  type: SET_NEXT_QUESTION,
  nextQuestionObj
})
